// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"d7301a9e","108":"9fc906d6","218":"f87094a0","247":"c477dad9","272":"c976bf6d","320":"a3fb249e","455":"ad6ca9d8","461":"93d00137","524":"6ee3b078","658":"a34e7e40","757":"baeef8c2","837":"234606df","858":"3f086965","859":"621c858c","941":"43afa8f4","956":"c5264002"}[chunkId] + ".chunk.js";
};